/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Invite_OneInputs */

const cs_users_invite_one = /** @type {(inputs: Users_Invite_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslat pozvánku`)
};

const en_users_invite_one = /** @type {(inputs: Users_Invite_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send invite`)
};

/**
* | output |
* | --- |
* | "Send invite" |
*
* @param {Users_Invite_OneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_invite_one = /** @type {((inputs?: Users_Invite_OneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Invite_OneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_invite_one(inputs)
	return cs_users_invite_one(inputs)
});